module.exports = __webpack_public_path__ + "85d6b271a14dc8c807ded9501750b682.pdf";